import styled from 'styled-components';

export const Container = styled.div<{ $backgroundColor: string }>`
    width: 100%;
    border-radius: 10px;
    padding: 12px 16px;
    max-width: 400px;
    box-sizing: border-box;
    background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const Title = styled.p<{ $textColor: string }>`
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    color: ${({ $textColor }) => $textColor};
    font-family: 'Inter', sans-serif;
`;
